/**
 * Raccoglitore dei permessi consultati dalla schermata corrente.
 *
 * usePermission viene chiamato durante il render: registrare da li' non puo'
 * provocare un aggiornamento di stato, altrimenti React segnalerebbe un
 * "update during render". Percio' la raccolta e' un Set fuori da React, sullo
 * stesso schema di lib/statoSimulazione, e i sottoscrittori vengono avvisati
 * in un microtask, quando il render e' finito.
 *
 * Senza nessun sottoscrittore (pannello chiuso) la registrazione e' una sola
 * Set.add: nessuna notifica, nessun render.
 *
 * La raccolta si azzera al cambio di percorso: quello che si vede sono i
 * permessi della schermata corrente, non di tutta la sessione. Le modali
 * aperte dopo si aggiungono, perche' non cambiano percorso.
 */

const consultati = new Set<string>()
const sottoscrittori = new Set<() => void>()
let percorsoCorrente: string | null = null
let notificaInCoda = false

const notifica = (): void => {
  if (sottoscrittori.size === 0 || notificaInCoda) return
  notificaInCoda = true
  queueMicrotask(() => {
    notificaInCoda = false
    sottoscrittori.forEach(cb => cb())
  })
}

export const registraPermesso = (codice: string): void => {
  if (consultati.has(codice)) return
  consultati.add(codice)
  notifica()
}

/**
 * Da chiamare durante il render del componente montato PRIMA delle rotte,
 * cosi' che l'azzeramento preceda le registrazioni della nuova schermata.
 */
export const registraPercorso = (percorso: string): void => {
  if (percorso === percorsoCorrente) return
  percorsoCorrente = percorso
  consultati.clear()
  notifica()
}

export const leggiPermessiConsultati = (): string[] => Array.from(consultati)

export const sottoscriviRaccolta = (cb: () => void): (() => void) => {
  sottoscrittori.add(cb)
  return () => {
    sottoscrittori.delete(cb)
  }
}
